(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mcg-adventskalender-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mcgAklInit) return;
    window.__mcgAklInit = true;

    function closeOthers(door) {
      var track = door.closest('[data-akl-track]');
      if (!track) return;
      track.querySelectorAll('.mcg-akl__door.is-open').forEach(function (d) { if (d !== door) d.classList.remove('is-open'); });
    }
    function rattle(door) {
      door.classList.remove('is-rattling'); void door.offsetWidth; door.classList.add('is-rattling');
      clearTimeout(door.__mcgT);
      door.__mcgT = setTimeout(function () { door.classList.remove('is-rattling'); }, 1600);
    }
    function activate(door) {
      if (door.classList.contains('is-closed')) { rattle(door); return; }
      if (door.classList.contains('is-open')) { door.classList.remove('is-open'); return; }
      closeOthers(door); door.classList.add('is-open');
    }
    function updateArrows(track) {
      var wrap = track.closest('.mcg-akl__doors-wrap');
      if (!wrap) return;
      var prev = wrap.querySelector('[data-akl-dir="-1"]');
      var next = wrap.querySelector('[data-akl-dir="1"]');
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    function initTracks() {
      document.querySelectorAll('.mcg-akl__doors-wrap--slider [data-akl-track]').forEach(function (t) {
        if (t.__aklBound) { updateArrows(t); return; }
        t.__aklBound = true;
        t.addEventListener('scroll', function () { updateArrows(t); }, { passive: true });
        updateArrows(t);
      });
    }

    document.addEventListener('click', function (e) {
      var arrow = e.target.closest('[data-akl-dir]');
      if (arrow) {
        var track = arrow.closest('.mcg-akl__doors-wrap').querySelector('[data-akl-track]');
        track.scrollBy({ left: Number(arrow.dataset.aklDir) * track.clientWidth * 0.8, behavior: 'smooth' });
        return;
      }
      var door = e.target.closest('.mcg-akl__door');
      if (!door) {
        document.querySelectorAll('.mcg-akl__door.is-open').forEach(function (d) { d.classList.remove('is-open'); });
        return;
      }
      activate(door);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var door = e.target.closest && e.target.closest('.mcg-akl__door');
      if (!door || e.target !== door) return;
      e.preventDefault(); activate(door);
    });

    document.addEventListener('shopify:block:select', function (e) {
      var door = e.target.closest && e.target.closest('.mcg-akl__door');
      if (!door) return;
      closeOthers(door); door.classList.add('is-open');
      door.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var door = e.target.closest && e.target.closest('.mcg-akl__door');
      if (door) door.classList.remove('is-open');
    });
    document.addEventListener('shopify:section:load', initTracks);
    window.addEventListener('resize', initTracks);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTracks); else initTracks();

    // Countdown
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function tickCountdowns() {
      document.querySelectorAll('[data-akl-countdown]').forEach(function (el) {
        var target = new Date(el.getAttribute('data-akl-countdown')).getTime();
        if (isNaN(target)) return;
        var diff = Math.max(0, Math.floor((target - Date.now()) / 1000));
        var units = el.querySelector('[data-cd-units]');
        var done = el.querySelector('[data-cd-done]');
        if (diff === 0) {
          if (done) { if (units) units.hidden = true; done.hidden = false; }
          else el.hidden = true;
          return;
        }
        var map = { d: Math.floor(diff / 86400), h: Math.floor(diff % 86400 / 3600), m: Math.floor(diff % 3600 / 60), s: diff % 60 };
        el.querySelectorAll('[data-cd]').forEach(function (n) {
          var v = map[n.getAttribute('data-cd')];
          n.textContent = n.getAttribute('data-cd') === 'd' ? String(v) : pad(v);
        });
      });
    }
    tickCountdowns();
    setInterval(tickCountdowns, 1000);
    document.addEventListener('shopify:section:load', tickCountdowns);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mcg-adventskalender-tuerchen"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mcgAdventInit) return;
    window.__mcgAdventInit = true;

    function closeOthers(door) {
      var grid = door.closest('.mcg-ak__grid');
      if (!grid) return;
      grid.querySelectorAll('.mcg-ak__door.is-open').forEach(function (d) {
        if (d !== door) d.classList.remove('is-open');
      });
    }

    function rattle(door) {
      door.classList.remove('is-rattling');
      void door.offsetWidth;
      door.classList.add('is-rattling');
      clearTimeout(door.__mcgT);
      door.__mcgT = setTimeout(function () { door.classList.remove('is-rattling'); }, 1600);
    }

    function activate(door, target) {
      if (door.classList.contains('is-closed')) { rattle(door); return; }
      var link = target && target.closest('a');
      if (door.classList.contains('is-open')) {
        if (!link) door.classList.remove('is-open');
        return;
      }
      if (link) return;
      closeOthers(door);
      door.classList.add('is-open');
    }

    document.addEventListener('click', function (e) {
      var door = e.target.closest('.mcg-ak__door');
      if (!door) {
        document.querySelectorAll('.mcg-ak__door.is-open').forEach(function (d) { d.classList.remove('is-open'); });
        return;
      }
      activate(door, e.target);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var door = e.target.closest && e.target.closest('.mcg-ak__door');
      if (!door || e.target !== door) return;
      e.preventDefault();
      activate(door, null);
    });

    // Im Shopify-Editor: ausgewählten Block automatisch öffnen
    document.addEventListener('shopify:block:select', function (e) {
      var door = e.target.closest && e.target.closest('.mcg-ak__door');
      if (door) { closeOthers(door); door.classList.add('is-open'); }
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var door = e.target.closest && e.target.closest('.mcg-ak__door');
      if (door) door.classList.remove('is-open');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
